// eslint-disable-next-line import/prefer-default-export
export enum FEES {
  EXTENDED_MILEAGE_FEE = 'EXTENDED_MILEAGE_FEE',
}
